import React from 'react';
import { Flex, Text } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { StringComparatorMultiEditor } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import ResourceEnumNotEqualsComparator from "./ResourceEnumNotEqualsComparator.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.condition.comparator.type.resourceEnum.ResourceEnumNotEqualsComparatorEditor');
export default function ResourceEnumNotEqualsComparatorEditor(props) {
  const {
    value,
    suggestor
  } = props;
  const value1 = ResourceEnumNotEqualsComparator.getValue1(value);
  const onModelChange = useValueChange(ResourceEnumNotEqualsComparator, props);
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "rowM",
    align: "center",
    children: [/*#__PURE__*/_jsx(Text, {
      children: t('name')
    }), /*#__PURE__*/_jsx(StringComparatorMultiEditor, {
      variant: "conditionText",
      selectionType: "text",
      allowCreate: false,
      suggestor: suggestor,
      value: value1,
      eventData: "setValue1",
      onChange: onModelChange
    })]
  });
}
ResourceEnumNotEqualsComparatorEditor.isInline = true;